import { castArray, range, sample, wait } from 'vtils'

export async function loopUntil<T>(
  fn: () => Promise<T>,
  condition: (res: T) => boolean,
  delay: number | number[] = range(100, 500, 10),
): Promise<T> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const res = await fn()
    if (condition(res)) {
      return res
    }
    await wait(sample(castArray(delay))!)
  }
}
